import PropTypes from 'prop-types'

const XYKeyPairPropType = PropTypes.shape({ x: PropTypes.string, y: PropTypes.string })

export default XYKeyPairPropType
